import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
  FunctionField,
} from 'react-admin'

export const ListSliders: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List {...rest} data-testid="list">
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" sortable={false} />
        <TextField label="Slug" source="slug" sortable={false} />
        <FunctionField
          label="Visibilidade"
          render={(record: any) => (record?.active ? 'Ativo' : 'Inativo')}
          sortable={false}
        />
        <TextField label="Ordem" source="order" sortable={false} />
      </Datagrid>
    </List>
  )
}
